var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"display-2",attrs:{"align-center":""}},[_vm._v("Du musst dich verlaufen haben. Hier ist nichts")])])}]

export { render, staticRenderFns }